const demoList = {
  Home: '',
  Contact: 'contact',
  'Privacy and Policy': 'privacy',
  'Terms and Conditions': 'terms',
  Resume: 'resume',
};

export default demoList;
